import { createContext } from "react";

import { SLOT_PLACE_AT_ANCHOR, type SlotLanding, type SlotPlace } from "../../../utils/redline-insertion-slot";

export interface InsertionLandings {
  landingOf: (cardId: string, anchorBookmark: string) => SlotLanding | null;
  isRankingSlotOf: (cardId: string) => boolean;
  placeOf: (cardId: string, anchorBookmark: string) => Promise<SlotPlace>;
}

export const NO_INSERTION_LANDINGS: InsertionLandings = { landingOf: () => null, isRankingSlotOf: () => false, placeOf: () => Promise.resolve(SLOT_PLACE_AT_ANCHOR) };

export const InsertionLandingsContext = createContext<InsertionLandings>(NO_INSERTION_LANDINGS);
